import styled from '@emotion/styled'
import mq from 'theme/mediaQueries'

export const Container = styled.div`
  margin: 0 auto;
  max-width: 1380px;
  padding: 0 20px 20px;
`

export const Content = styled.div`
  column-gap: 20px;

  ${mq({
    display: ['block', 'block', 'grid'],
    gridTemplateColumns: ['0 100%', '0 100%', '250px auto'],
  })}
`

export const InfoCards = styled.div`
  & > div:first-of-type {
    margin: 0 auto;
    margin-right: 10px;

    ${mq({
      width: ['80%', '80%', '50%'],
    })}
  }
  
  & > div:nth-of-type(2) {
    ${mq({
      margin: ['20px auto', '20px auto', '0 10px 0'],
      width: ['80%', '80%', '50%'],
    })}
  }

  ${mq({
    display: ['block', 'block', 'flex'],
  })}
`

export const TopPage = styled.div`
  ${mq({
    display: ['block', 'block', 'flex'],
  })}

  justify-content: space-between;
  padding-right: 14px;
`

export const TopPageOptions = styled.div`
  display: flex;
  text-align: right;
  padding-bottom: 20px;

  button {
    margin-left: 10px;
  }
`
